module.exports = __webpack_public_path__ + "images/feishu/tower-lark-18b375589a59796b65ed4ec985ad39f9.png";